import React, { useRef } from "react";
import { Box, Grid, Typography } from "@mui/material";

import Banner from "../../../../Common/Components/Banner";
import CarModel from "../../../../Common/Components/CarModel";
import Intro from "../../../../Common/Components/Intro";
import InterestDealer from "../../../../Common/Components/InterestDealer";
import MeetTheFamily from "../../../../Common/Components/MeetTheFamily";
import DetailedInfo from "../../../../Common/Components/DetailedInfo";
import Faq from "../../../../Common/Components/Faq";
import ShowInterest from "../../../../Common/Container/showintrestCon";
import Wsp from "../../../contact/Component/Floatingwsp";

import SyrosEvNavbar from "./SyrosEvNavbar";
import AccordionShowcase from "./AccordionShowcase";
import PeekCarousel from "./PeekCarousel";
import ChargingSpeed from "./ChargingSpeed";
import VariantPricing from "./VariantPricing";

import {
  BannerData,
  BrochureLink,
  IntroData,
  HighlightsData,
  CircleData,
  CircleDataByTrim,
  TrimOptions,
  DetailShowcaseData,
  ChargingData,
  ConfidenceData,
  ExteriorShowcase,
  InteriorShowcase,
  SafetyShowcase,
  AdasShowcase,
  ComfortShowcase,
  ConnectivityShowcase,
  VariantData,
  TrimData,
  DetailInfo,
  FaqData,
} from "./Data";

export default function SyrosEV() {
  const showInterestRef = useRef(null);
  const exteriorRef = useRef(null);
  const interiorRef = useRef(null);
  const safetyRef = useRef(null);
  const adasRef = useRef(null);
  const comfortRef = useRef(null);
  const connectivityRef = useRef(null);

  const refs = {
    exterior: exteriorRef,
    interior: interiorRef,
    safety: safetyRef,
    adas: adasRef,
    comfort: comfortRef,
    connectivity: connectivityRef,
    showInterest: showInterestRef,
  };

  const scrollToSection = (section) => {
    const ref = refs[section];
    if (ref?.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleBookNow = () => {
    window.open("tel:+911800108500", "_self");
  };

  return (
    <Box sx={{ overflowX: "hidden" }}>
      <Banner bannerData={BannerData} />
      <SyrosEvNavbar
        scrollToSection={scrollToSection}
        brochureLink={BrochureLink}
        onBookNow={handleBookNow}
      />

      <Grid container justifyContent="center">
        <Grid item xs={12} sm={11} py={1}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              fontFamily: "KIAbodyLatinbasic_Regular",
              textAlign: "center",
              display: "block",
            }}
          >
            Disclaimer: ^Range as per ARAI MIDC-Full. #39 minutes to charge from 10% to 80%
            using a 100 kW DC Fast Charger under standard test conditions. Actual charging time
            may vary. Vehicle shown is for representation purposes only. Colour, features,
            specifications, and price may vary. Please contact your nearest Kia dealer for
            details. *T&amp;C applies
          </Typography>
        </Grid>
      </Grid>

      <InterestDealer
        Intrestdata={BrochureLink}
        onScrollToInterest={() => scrollToSection("showInterest")}
      />

      <Intro data={IntroData} />

      <AccordionShowcase {...HighlightsData} />

      <CarModel
        model="Syros EV"
        CircleData={CircleDataByTrim}
        trimOptions={TrimOptions}
        bgCar="https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FDesktop_Explorer012.mp4?alt=media&token=06e75136-5b92-4a05-9173-0e6cceabacdc"
      />

      <div ref={showInterestRef} className="section-anchor">
        <ShowInterest someValue="Syros EV" />
      </div>

      <AccordionShowcase {...DetailShowcaseData} reverse />

      <ChargingSpeed
        data={ChargingData}
        onBookNow={handleBookNow}
        onLocateCharger={() => scrollToSection("showInterest")}
      />

      <AccordionShowcase {...ConfidenceData} />

      <div ref={exteriorRef} className="section-anchor">
        <PeekCarousel {...ExteriorShowcase} />
      </div>

      <div ref={interiorRef} className="section-anchor">
        <PeekCarousel {...InteriorShowcase} />
      </div>

      <div ref={safetyRef} className="section-anchor">
        <PeekCarousel {...SafetyShowcase} />
      </div>

      <div ref={adasRef} className="section-anchor">
        <PeekCarousel {...AdasShowcase} />
      </div>

      <div ref={comfortRef} className="section-anchor">
        <PeekCarousel {...ComfortShowcase} />
      </div>

      <div ref={connectivityRef} className="section-anchor">
        <PeekCarousel {...ConnectivityShowcase} />
      </div>

      <VariantPricing
        variants={VariantData}
        onConfigure={() => scrollToSection("showInterest")}
      />

      {/* <MeetTheFamily TrimData={TrimData} data={CircleData} /> */}

      <DetailedInfo
        DetailInfo={DetailInfo}
        onScrollToInterest={() => scrollToSection("showInterest")}
      />

      <Faq FaqData={FaqData} />
      <Wsp />
    </Box>
  );
}
